// extracted by mini-css-extract-plugin
export default {"panelHero":"panelHero_panelHero__iIDbi","icon":"panelHero_icon__SADn5","text":"panelHero_text__Qqysi","title":"panelHero_title__AXBwC","subtitle":"panelHero_subtitle__L8Sgp"};